import { useEffect } from 'react';
import useAuthentication from './useAuthentication';

export default history => {
  const [isAuthenticated] = useAuthentication();
  const { push: pushHistory } = history;

  useEffect(() => {
    if (isAuthenticated) {
      if (pushHistory) {
        pushHistory('/');
      } else {
        window.location.replace('/');
      }
    }
  }, [isAuthenticated, pushHistory]);
};
